export default __webpack_public_path__ + "static/media/kvalexandr.06f1f0e5.jpg";